// avatarConfig.js

// BASE
import avatarBlank from "./avatar_assets/base/avatar_blank.png";

// FACES
import assetFace1 from "./avatar_assets/faces/asset_face1.png";
import assetFace2 from "./avatar_assets/faces/asset_face2.png";
import assetFace3 from "./avatar_assets/faces/asset_face3.png";
import assetFace4 from "./avatar_assets/faces/asset_face4.png";

// HAIR
import assetHairGirl from "./avatar_assets/hair/asset_hair_girl.png";
import assetHair from "./avatar_assets/hair/asset_hair.png";
import assetHairMan1 from "./avatar_assets/hair/asset_hair_man1.png";

// CLOTHES
import tricouBlue from "./avatar_assets/clothes/tricou_blue.png";
import tricouConti from "./avatar_assets/clothes/tricou_conti.png";
import tricou from "./avatar_assets/clothes/tricou.png";

export const avatarBase = avatarBlank;

export const avatarCategories = [
  {
    id: "face",
    label: "Fata",
  },
  {
    id: "hair",
    label: "Par",
  },
  {
    id: "clothes",
    label: "Haine",
  },
  {
    id: "glasses",
    label: "Ochelari",
  },
  {
    id: "accessories",
    label: "Accesorii",
  },
  {
    id: "background",
    label: "Fundal",
  },
];

export const avatarOptions = {
  face: [
    {
      id: "asset_face1",
      name: "Fata 1",
      image: assetFace1,
    },
    {
      id: "asset_face2",
      name: "Fata 2",
      image: assetFace2,
    },
    {
      id: "asset_face3",
      name: "Fata 3",
      image: assetFace3,
    },
     {
      id: "asset_face4",
      name: "Fata 4",
      image: assetFace4,
    },
  ],

  hair: [
    {
      id: "asset_hair",
      name: "Par 1",
      image: assetHair,
    },
    {
      id: "asset_hair_girl",
      name: "Par 2",
      image: assetHairGirl,
    },
     {
      id: "asset_hair_man1",
      name: "Par 3",
      image: assetHairMan1,
    },



  ],

  clothes: [
    {
      id: "tricou",
      name: "Tricou verde",
      image: tricou,
    },
    {
      id: "tricou_blue",
      name: "Tricou albastru",
      image: tricouBlue,
    },
    {
      id: "tricou_conti",
      name: "Tricou ContaLearn",
      image: tricouConti,
    },
  ],

  glasses: [],
  accessories: [],
background: [
  {
    id: "background_default",
    name: "Default",
    color: "#d6f2fe",
  },
  {
    id: "background_blue",
    name: "Albastru",
    color: "#7DD3FC",
  },
  {
    id: "background_green",
    name: "Verde",
    color: "#86EFAC",
  },
  {
    id: "background_yellow",
    name: "Galben",
    color: "#FDE68A",
  },
  {
    id: "background_purple",
    name: "Mov",
    color: "#C4B5FD",
  },
  {
    id: "background_pink",
    name: "Roz",
    color: "#FDA4AF",
  },
],
};

export const defaultAvatar = {
  face: "asset_face1",
  hair: "asset_hair",
  clothes: "tricou",
  glasses: null,
  accessories: null,
  background: null,
};

export const getAvatarAsset = (category, id) => {
  if (!id || !avatarOptions[category]) {
    return null;
  }

  return (
    avatarOptions[category].find((option) => option.id === id) || null
  );
};